import { getElementHeight, isElementVisible, getMaxVisibleHeight } from './domHelpers';

/**
 * Calculate desktop header offset
 * Handles sticky headers, alerts, and shrinking navigation bars
*/
export const getDesktopHeaderOffset = ({ dom, config, headerHeight }) => {
	if (config.isNotSticky) {
		return 0;
	}

	if (
		!config.noShrink &&
		dom.alert?.offsetHeight > 0 &&
		isElementVisible(dom.alert)
	) {
		return dom.alert.offsetTop + dom.alert.offsetHeight;
	}

	const desktopNavbar = document.querySelector(
		'.navbar.shrink-header-nav, .navbar.sticky-header-nav'
	);
	const navbarHeight = isElementVisible(desktopNavbar)
		? getElementHeight(desktopNavbar)
		: 0;
	return headerHeight + navbarHeight;
};

/**
 * Calculate mobile fixed header offset
 * Handles alert banners and shrunk navigation bars on page load and scroll
*/
export const getMobileFixedHeaderOffset = ({ dom, headerHeight, isPageLoad }) => {
	if (isPageLoad) {
		const alertBanner = dom.header.querySelector('.content-alert-banner');
		if (alertBanner && !alertBanner.classList.contains('hide')) {
			return headerHeight - getElementHeight(alertBanner);
		}
	}

	const shrunkMobileNavbar = window.$(
		'.nav-button-container.shrink-header-nav .navbar.fixed'
	);
	if (shrunkMobileNavbar.length > 0 && shrunkMobileNavbar.is(':visible')) {
		return getElementHeight(shrunkMobileNavbar[0]);
	}

	return getMaxVisibleHeight(dom.header);
};

/**
 * Calculate mobile default header offset
 * Handles different mobile header types: minimal container, default header with vCard
*/
export const getMobileDefaultHeaderOffset = ({ dom, config }) => {
	// Check for minimal header container first
	const headerMinimalContainer = dom.header.querySelector(
		'.header-minimal-container'
	);
	if (headerMinimalContainer && window.$(headerMinimalContainer).is(':visible')) {
		return getMaxVisibleHeight(headerMinimalContainer);
	}

	// Check for default header
	const headerDefault = dom.header.querySelector('.header-default');
	const headerVCard = dom.header.querySelector('.vcard');
	if (headerDefault && window.$(headerDefault).is(':visible') && isElementVisible(headerDefault)) {
		return getMaxVisibleHeight(headerVCard);
	}

	return getMaxVisibleHeight(config.mobileNavbar) + getMaxVisibleHeight(headerVCard);
};

// Get header offset based on device and header configuration
export const getHeaderOffset = ({ dom, config, DDC, isPageLoad = false }) => {
	const headerHeight = isElementVisible(dom.header)
		? getElementHeight(dom.header)
		: 0;

	if (!DDC.client.isMobile) {
		return getDesktopHeaderOffset({ dom, config, headerHeight });
	}

	if (config.isEntireMobileHeaderFixed) {
		return getMobileFixedHeaderOffset({ dom, headerHeight, isPageLoad });
	}

	return getMobileDefaultHeaderOffset({ dom, config });
};
